import { Navigate, Outlet, useLocation } from 'react-router'

import { useUser } from '@/domains/auth'

import { memberPath } from './network-path'

export function PublicRoute() {
  const { user, isLoading } = useUser()
  const { pathname, search } = useLocation()

  if (isLoading) return null
  if (user) return <Navigate to={`${memberPath(pathname)}${search}`} replace />
  return <Outlet />
}
